export default __webpack_public_path__ + "static/media/b-RMX-1.92e9478a.png";